import { ReactElement } from 'react';

import { AnimatedMentalSate } from './components/AnimatedMentalState';
import { DownloadCard } from './components/DownloadCard';
import { Hero } from './components/hero';
import { InformationSection } from './components/InformationSection';
import { InstallationInstructions } from './components/InstallationInstructions';
import * as S from './PageContent.styles';


export const DownloadPageContent = (): ReactElement => {
  return (
    <S.Wrapper>
      <S.Header>
        <Hero />
      </S.Header>
      <InstallationInstructions />
      <AnimatedMentalSate />
      <S.CardsContainer>
        <InformationSection />
      </S.CardsContainer>
      <DownloadCard />
    </S.Wrapper>
  );
};
